import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions, callOperation } from "async-ops";
import MdaePopup, {
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupTitle,
} from "../../../common_components/common_widgets/popup";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../../common_components/common_widgets/data-grid";
import {
  CURRENT_REPORT_OBJECT,
  CURRENT_REPORT_PARAMETER_OBJECT,
  exportFormatForLongRunningReports,
  TOGGLE_REPORT_PARAMETER_POPUP,
  TOGGLE_VIEW_REPORT_POPUP,
} from "./reducers/audit-list-reducer";
import { cloneDeep, isEqual } from "lodash";
import "./index.scss";
import { GET_REPORT_PACKAGE_LIST } from "./services/get-report-package-list";
import { UPDATE_PREFERENCE } from "../../external-dashboard/services/update-preference";
import { ADD_REPORT_PACKAGE_FAVORITE } from "./services/add-report-package-favorite";
import { DELETE_REPORT_PACKAGE_FAVORITE } from "./services/delete-report-package-favotite";
import { GET_ENV_VARIABLE } from "./services/get-env-variable";
import { parameterizedReportList, reportParemeters } from "./constant";
import MdaeCheckBox from "../../../common_components/common_widgets/check-box";
import { forEachLeadingCommentRange } from "typescript";
import MdaeButton from "../../../common_components/common_widgets/button";
import $ from "jquery";
import { DISABLE_ANIMATION_CONFIG } from "../../../common_components/common_widgets/popup/component";
import MdaeRadioGroup from "../../../common_components/common_widgets/radio-group";
import { HIDE_LOADER, SHOW_LOADER } from "../../../common_components/mdae-common-reducer";
import { INSERT_AUDIT_REPORT_LOG } from "./services/insert-audit-report-log";
import { GET_PREFERENCE } from "../../external-dashboard/services/get-preference";
import { GET_USER_PREFERENCE } from "../../external-dashboard/services/get-userpreference";
const nonParameterizedReportList = ["narrative summary report"];
const isNonParameterizedReport = (reportName) => {
  return (
    nonParameterizedReportList.includes(reportName?.toLowerCase()) === true
  );
};
const ViewReport: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const [currentReportName, setCurrentReportName] = useState(null);
  var reportList = useSelector(
    (state: any) => state["auditListReducer"].reportList,
    isEqual
  );
  var currentReportPromptObject = useSelector(
    (state) => state["auditListReducer"].currentReportPromptObject,
    isEqual
  );

  var currentReportObject = useSelector(
    (state) => state["auditListReducer"].currentReportObject,
    isEqual
  );
  var isReportPopupVisible = useSelector(
    (state) => state["auditListReducer"].isReportPopupVisible,
    isEqual
  );
  //This is for when you have no cache in db
  const [reportParameterCookie, setreportParameterCookie] = useState(
    JSON.parse(
      localStorage.getItem("External_MDAuditEnterprise_reportParameterCookie")
    )
  );  
  let tempReportParemeters =
    reportParameterCookie != undefined
      ? reportParameterCookie
      : reportParemeters;

  useEffect(() => {
    dispatch(
      actions.asyncOperationStart(GET_REPORT_PACKAGE_LIST, {
        userId: props.userId,
        isExternalReport: true,
      })
    );
  }, [props.userId, props.currentSelectedRowData.eaAuditId]);

  const toggleViewReportPopupVisible = (isVisible) => {
    dispatch({
      type: TOGGLE_VIEW_REPORT_POPUP,
      data: {
        isReportPopupVisible: isVisible,
      },
    });
  };

  const toggleReportParameterPopupVisible = (isVisible) => {
    dispatch({
      type: TOGGLE_REPORT_PARAMETER_POPUP,
      data: {
        isVisible: isVisible,
      },
    });
  };
  const updatePreference = (result) => {
    dispatch(
      actions.asyncOperationStart(UPDATE_PREFERENCE, {
        name: result.name,
        settings: result.settings,
        reportType:result.reportType
      })
    );
  };
  const getUserPreference = (name,reportType) => {
   return callOperation(GET_USER_PREFERENCE, {
       name:name,
       reportType:reportType 
      })      
  };
  let reportParamCache={
    name:'',
    settings:'',
    reportType:''
  }

  const onValueChanged=useCallback((e)=>{
  if(Object.keys(currentReportObject).length){
    let obj=cloneDeep(currentReportObject);
    obj.exportFormatReportPackage.selected=e.value;
    obj.exportFormatReportPackage.selectedValue=exportFormatForLongRunningReports.items.indexOf(e.value);
    dispatch({ type: CURRENT_REPORT_OBJECT, data: obj });
    let index = tempReportParemeters.findIndex((e) => e.reportTitle === currentReportPromptObject?.reportTitle);
    tempReportParemeters[index].exportFormatReportPackage=obj.exportFormatReportPackage;    
    dispatch({
      type: CURRENT_REPORT_PARAMETER_OBJECT,
      data: tempReportParemeters[index],
    });
  }
}, [currentReportObject]);

  const onFavorite = (favoriteInd, reportPackageId, reportUserAssocId) => {
    var faveInd = favoriteInd === 0 ? 1 : 0;
    var favoriteData = {
      reportPackageId: reportPackageId,
      favoriteInd: faveInd,
      clientId: 0,
      updatedBy: props.userId,
      createdBy: props.userId,
      userId: props.userId,
    };
    if (reportUserAssocId < 1) {
      dispatch(
        actions.asyncOperationStart(ADD_REPORT_PACKAGE_FAVORITE, favoriteData)
      );
    } else {
      dispatch(
        actions.asyncOperationStart(
          DELETE_REPORT_PACKAGE_FAVORITE,
          reportUserAssocId
        )
      );
    }
    setTimeout(() => {
      dispatch(
        actions.asyncOperationStart(GET_REPORT_PACKAGE_LIST, {
          userId: props.userId,
          isExternalReport: true,
        })
      );
    }, 1000);
  };
  const getReportParamValue = (paramList, paramName) => {
    var t = $.grep(paramList, function(e: any) {
      return e.id == paramName;
    });

    return t;
  };

  const  writeAuditReportLog=(reportParams, reportUrl,t) =>{
  dispatch({ type: SHOW_LOADER });
   callOperation(INSERT_AUDIT_REPORT_LOG, reportParams).then(
    (response) => {
      dispatch({ type: HIDE_LOADER });
      if (response !== null && response.auditReportLogId > 0) {
        t.location = reportUrl + "?reportToken=" + response.uniqueGuidId + "&reportLogId=" + response.auditReportLogId;
      }
      else {
        dispatch({ type: HIDE_LOADER });
        return false;
      }
    }
  ).catch(() =>{
    dispatch({ type: HIDE_LOADER });
    return false;
  });
}

  const onRunReport = (currentReportObject, currentReportPromptObject) => {
    toggleReportParameterPopupVisible(false);
    if (currentReportObject) {
      var t = window.open("");
      callOperation(GET_ENV_VARIABLE, "BaseUrl").then((response) => {
        var dashboardUrl = window.location.origin + "/Analyzer/";
        var api =
          (currentReportPromptObject || currentReportObject)
            .reportPackageType === "Package"
            ? "PackagePreview"
            : "ReportPreview";
        var reportUrl = dashboardUrl + api;
        var auditList = [];
        auditList.push(props.currentSelectedRowData.eaAuditId);
        //Audit Financial Results Summary
        var pAFRSHideCaseLevelData = 1;
        var pHideRoundLevelData = 0;
        var pAFRSHidePHI = 1;
        var pHideProcessManager = 0;
        var pHideCasesWithoutFinalOutcome = 1;
        var pADOSHideCaseFinalOutcomePieChart = 0;
        var pADOSHideFinalDeterminationRoundPieChart = 0;
        var pHideStatus =0;
        var reportParams = {};
        var exportFormatForLongRunningReports = currentReportObject.exportFormatReportPackage.selectedValue == 0 ? "pdf" : "docx";        
        const isExternalAudit = true;
        if (currentReportObject.reportPackageType == "Report") {
          if (
            currentReportObject.reportName == "Audit Financial Results Summary"
          ) {
            pAFRSHideCaseLevelData =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide case level data"
              )[0].selected == true
                ? 1
                : 0;
            pHideRoundLevelData =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide Round level data"
              )[0].selected == true
                ? 1
                : 0;
            pAFRSHidePHI =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide PHI"
              )[0].selected == true
                ? 1
                : 0;
            pHideProcessManager =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide Process Manager"
              )[0].selected == true
                ? 1
                : 0;
            pHideCasesWithoutFinalOutcome =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide cases without a final outcome"
              )[0].selected == true
                ? 1
                : 0;
             reportParams = {
                ReportPackageId: currentReportObject.reportPackageId,
                EaAuditId: props.currentSelectedRowData.eaAuditId,
                AuditIdList: auditList.toString(),
                pAFRSHideCaseLevelData: pAFRSHideCaseLevelData,
                pHideRoundLevelData: pHideRoundLevelData,
                pAFRSHidePHI: pAFRSHidePHI,
                pHideProcessManager: pHideProcessManager,
                pHideCasesWithoutFinalOutcome: pHideCasesWithoutFinalOutcome,
                isExternalAudit: isExternalAudit,
                AuditId: props.currentSelectedRowData.eaAuditId,
                AuditName: props.currentSelectedRowData.auditTitle,
                ExportFormatForLongRunningReports: exportFormatForLongRunningReports
            };   
          } else if (
            currentReportObject.reportName ==
            "Audit Appeal/Denial Outcome Summary"
          ) {
            pHideRoundLevelData =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide Round level data"
              )[0].selected == true
                ? 1
                : 0;
            pHideProcessManager =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide Process Manager"
              )[0].selected == true
                ? 1
                : 0;
            pHideCasesWithoutFinalOutcome =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide cases without a final outcome"
              )[0].selected == true
                ? 1
                : 0;
            pADOSHideCaseFinalOutcomePieChart =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide Case Final Outcome Pie Chart"
              )[0].selected == true
                ? 1
                : 0;
            pADOSHideFinalDeterminationRoundPieChart =
              getReportParamValue(
                currentReportPromptObject.prompt,
                "Hide Final Determination Round Pie Chart"
              )[0].selected == true
                ? 1
                : 0;
            reportParams = {
                ReportPackageId: currentReportObject.reportPackageId,
                EaAuditId: props.currentSelectedRowData.eaAuditId,
                AuditIdList: auditList.toString(),
                pHideRoundLevelData: pHideRoundLevelData,
                pHideProcessManager: pHideProcessManager,
                pHideCasesWithoutFinalOutcome: pHideCasesWithoutFinalOutcome,
                pADOSHideCaseFinalOutcomePieChart:pADOSHideCaseFinalOutcomePieChart,
                pADOSHideFinalDeterminationRoundPieChart:pADOSHideFinalDeterminationRoundPieChart,
                isExternalAudit: isExternalAudit,
                AuditId: props.currentSelectedRowData.eaAuditId,
                AuditName: props.currentSelectedRowData.auditTitle,
                ExportFormatForLongRunningReports: exportFormatForLongRunningReports
            }; 
          } else if (
            currentReportObject.reportName == "Narrative Summary Report"
          ) {
            reportParams = {
                ReportPackageId: currentReportObject.reportPackageId,
                AuditId: props.currentSelectedRowData.eaAuditId,
                AuditName: props.currentSelectedRowData.auditTitle,
                ExportFormatForLongRunningReports: exportFormatForLongRunningReports
            }; 
          }
          else if (currentReportObject.reportName == 'Title Page') {
              pHideProcessManager = getReportParamValue(currentReportPromptObject.prompt, 'Hide Process Manager')[0].selected == true ? 1 : 0;
              pHideStatus = getReportParamValue(currentReportPromptObject.prompt, 'Hide Audit Status')[0].selected == true ? 1 : 0;
              reportParams = {
                ReportPackageId: currentReportObject.reportPackageId,
                AuditIdList: props.currentSelectedRowData.eaAuditId.toString(),
                pHideProcessManager: pHideProcessManager,
                pHideStatus:pHideStatus,
                isExternalAudit: isExternalAudit,
                AuditId: props.currentSelectedRowData.eaAuditId,
                AuditName: props.currentSelectedRowData.auditTitle,
                ExportFormatForLongRunningReports: exportFormatForLongRunningReports
            }; 
          }
        }
        reportParamCache.name = currentReportObject.reportName.replace('/','');
        reportParamCache.settings = JSON.stringify(currentReportPromptObject);
        reportParamCache.reportType = "ExternalAudit";
        updatePreference(reportParamCache);
        writeAuditReportLog(reportParams, reportUrl,t);
      });
    }
    dispatch({ type: CURRENT_REPORT_PARAMETER_OBJECT, data: null });
  };

  const setReportParameter = (reportName) => {
        
   return getUserPreference(reportName.replace('/',''),"ExternalAudit").then(
    (response) => {
      let reportCookie;
      let tempParemeters;
      let result;
      if(response!=null && !Array.isArray(response)){
      reportCookie = JSON.parse(response.settings); 
      tempParemeters = reportCookie != undefined ? reportCookie : reportParemeters;
      result=tempParemeters;
    }
    else  {
      reportCookie= reportParameterCookie;  
      tempParemeters = reportCookie != undefined ? reportCookie : reportParemeters;
      const reportParemeterIndex = reportParemeters.findIndex(
        (e) => e.reportTitle === reportName
      );
      const index = tempParemeters.findIndex((e) => e.reportTitle === reportName);
      if(!tempParemeters[index].exportFormatReportPackage || tempParemeters[index].exportFormatReportPackage==undefined){
        tempParemeters[index].exportFormatReportPackage=exportFormatForLongRunningReports;
      }
      result=tempParemeters[index];
    }  
    dispatch({
      type: CURRENT_REPORT_PARAMETER_OBJECT,
      data: result,
    }); 
    return result;
    })
    
  };

  const onPreview = (
    reportPackageId,
    reportPackageType,
    reportName,
    data,
    isRunReportDirect
  ) => {
    setCurrentReportName(reportName);
    let promiseCall = null;
    if(!isNonParameterizedReport(reportName)){
      promiseCall = setReportParameter(reportName)
    }else{
      promiseCall = Promise.resolve(null);
    }
    promiseCall.then((tempParameters) =>{
      var isParameterizedReport = false;
      var reportObject = {
        reportPackageId: reportPackageId,
        reportPackageType: reportPackageType,
        reportName: reportName,
        exportFormatReportPackage:tempParameters != null  && tempParameters.exportFormatReportPackage!=undefined ? tempParameters.exportFormatReportPackage : exportFormatForLongRunningReports
      };
      dispatch({ type: CURRENT_REPORT_OBJECT, data: reportObject });
      isParameterizedReport =
        $.grep(parameterizedReportList, function(s) {
          return s.reportName == reportName;
        }).length > 0
          ? true
          : false;
      if (isParameterizedReport) {
        var paramReport = $.grep(reportParemeters, function(e) {
          return e.reportTitle == reportName;
        });
      }
      if (isRunReportDirect) {
        setTimeout(() => {
          onRunReport(reportObject, tempParameters);
        }, 1000);
      } else {
        toggleReportParameterPopupVisible(true);
      }
    })
    
    
  };
  const checkIsParameterizedReport = (reportPackageType, reportName, data) => {
    var isParameterizedReport =
      $.grep(parameterizedReportList, function(s: any) {
        return s.reportName == reportName;
      }).length > 0
        ? true
        : false;
    if (isParameterizedReport) return true;
    else return false;
  };
  const getReportGridOptions = (eaAuditId) => {
    const ReportGridOptions: IMdaeDataGridProps = {
      id: "pnlViewReport",
      height: 438,
      paging: { pageSize: 10 },
      filterRow: { visible: true },
      headerFilter: { visible: true },
      mdaeColumns: [
        {
          dataField: "favoriteInd",
          caption: "",
          allowSorting: false,
          cellRender: (cellData) => {
            return cellData.data.favoriteInd === 0 ? (
              <button
                className="grid-buttons"
                onClick={() => {
                  onFavorite(
                    cellData.data.favoriteInd,
                    cellData.data.reportPackageId,
                    cellData.data.reportUserAssocId
                  );
                }}
              >
                <i
                  className="glyphicon glyphicon-star-empty application-section-primary-color"
                  style={{ fontSize: "16px" }}
                />
              </button>
            ) : (
              <button
                className={"grid-buttons"}
                onClick={() => {
                  onFavorite(
                    cellData.data.favoriteInd,
                    cellData.data.reportPackageId,
                    cellData.data.reportUserAssocId
                  );
                }}
              >
                <i
                  className="glyphicon glyphicon-star application-section-primary-color"
                  style={{ fontSize: "16px" }}
                />
              </button>
            );
          },
          alignment: "center",
          allowFiltering: false,
          width: 60,
          fixed: true,
        },
        {
          dataField: "name",
          caption: "Name",
          cellRender: (cellData) => {
            return (
              <div
                title="Run report with existing parameters"
                id={
                  "btn-list-report-row-action-" + cellData.data.reportPackageId
                }
                style={{ cursor: "pointer" }}
                onClick={() => {
                  onPreview(
                    cellData.data.reportPackageId,
                    cellData.data.type,
                    cellData.data.name,
                    cellData.data,
                    true
                  );
                }}
              >
                <a className="application-section-primary-color">
                  {cellData.data.name}
                </a>
              </div>
            );
          },
          allowSorting: true,
          allowFiltering: true,
          allowHeaderFiltering: false,
        },
        {
          dataField: "actions",
          caption: "Actions",
          alignment: "center",
          cellRender: (cellData) => {
            return checkIsParameterizedReport(
              cellData.data.type,
              cellData.data.name,
              cellData.data
            ) === true ? (
              <div title="Edit report parameters" style={{ cursor: "pointer" }}>
                <button
                  id={
                    "btn-list-report-row-action-" +
                    cellData.data.reportPackageId
                  }
                  className={"grid-buttons"}
                  onClick={() => {
                    onPreview(
                      cellData.data.reportPackageId,
                      cellData.data.type,
                      cellData.data.name,
                      cellData.data,
                      false
                    );
                  }}
                >
                  <a className="application-section-primary-color">
                    <i
                      className={"fa fa-gear application-section-primary-color"}
                      style={{ color: "#36c389", fontSize: "15px" }}
                    />
                  </a>
                </button>
              </div>
            ) : (
              <div></div>
            );
          },
          allowFiltering: false,
          allowSorting: false,
          width: 80,
        },
        {
          dataField: "type",
          caption: "Type",
          allowFiltering: true,
          allowSorting: true,
          width: 250,
        },
        {
          dataField: "reportCategory",
          caption: "Category",
          allowFiltering: true,
          allowSorting: true,
          width: 250,
        },
      ],
      mdaeDataUpdaterConfig: [
        {
          actionType: GET_REPORT_PACKAGE_LIST,
          isAsyncComplete: true,
          widgetOptionBindings: {
            dataSource: undefined,
          },
        },
      ],
    };
    return ReportGridOptions;
  };
  const reportGrid = useMemo(() => {
    return getReportGridOptions(props.currentSelectedRowData.eaAuditId);
  }, [props.currentSelectedRowData.eaAuditId]);

  const getReportParameterTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleReportParameterPopupVisible(false);
          dispatch({ type: CURRENT_REPORT_PARAMETER_OBJECT, data: null });
        }}
      >
        Report Parameters
      </MdaePopupTitle>
    );
  };

  const getReportPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleViewReportPopupVisible(false);
        }}
      >
        Reports -{" "}
        {props.currentSelectedRowData.auditTitle == null
          ? props.currentSelectedRowData.title
            ? props.currentSelectedRowData.title
            : ""
          : props.currentSelectedRowData.auditTitle}
      </MdaePopupTitle>
    );
  };
  return (
    <div>
      <MdaePopup
        animation={DISABLE_ANIMATION_CONFIG}
        height={550}
        width={1090}
        id={""}
        visible={isReportPopupVisible}
        mdaeTitleRender={getReportPopupTitle}
        mdaeContentRender={() => {
          return (
            <div className="report-grid-content">
              <MdaeDataGrid {...reportGrid}></MdaeDataGrid>
            </div>
          );
        }}
      ></MdaePopup>
      <MdaePopup
        deferRendering={false}
        height={600}
        width={850}
        id={""}
        mdaeTitleRender={getReportParameterTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_REPORT_PARAMETER_POPUP,
            reducerName: "auditListReducer",
            widgetOptionBindings: {
              visible: "isVisible",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              {currentReportPromptObject != undefined &&
              currentReportPromptObject != null ? (
                <div className={"report-content"}>
                  <div className={"report-title"}>
                    {currentReportPromptObject?.reportTitle}
                  </div>
                  <div style={{width:"70%"}}>
                    {currentReportPromptObject?.prompt
                      ?.filter((item) => item.type.toLowerCase() === "checkbox")
                      .map((propmtItem, i) => {
                        return (
                          <div
                            style={{ display: "flex", marginBottom: "10px" }}
                          >
                            <div className={"report-parameter-title"}>
                              {propmtItem.title}:
                            </div>
                            <MdaeCheckBox
                              id={
                                propmtItem.id +
                                "-" +
                                propmtItem.type +
                                "-" +
                                currentReportPromptObject?.reportTitle
                              }
                              defaultValue={propmtItem?.selected}
                              onValueChanged={(e) => {
                                tempReportParemeters.forEach((element, i) => {
                                  if (
                                    element.reportTitle ==
                                    currentReportPromptObject?.reportTitle
                                  ) {
                                    element.prompt.forEach((element, j) => {
                                      if (element.title == propmtItem.title) {
                                        tempReportParemeters[i].prompt[
                                          j
                                        ].selected = e.value;                                        
                                        dispatch({
                                          type: CURRENT_REPORT_PARAMETER_OBJECT,
                                          data: tempReportParemeters[i],
                                        });
                                      }
                                    });
                                  }
                                });
                              }}
                            ></MdaeCheckBox>
                          </div>
                        );
                      })}
                    <div  style={{ display: "flex", marginBottom: "10px" }}>
                   <div className={"report-parameter-title"}>
                    {"Export Format For Long Running Reports"}:
                    </div>
                    <MdaeRadioGroup
                    id={exportFormatForLongRunningReports.id}
                    items={exportFormatForLongRunningReports.items}
                    layout={"vertical"}
                    value={currentReportObject?.exportFormatReportPackage?.selected}
                    onValueChanged={onValueChanged}
                    />
                </div>
                  </div>
                </div>
              ) : (
                <div />
              )}
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlRunReportBtn"}
                  role={"primary"}
                  onClick={() => {
                    onRunReport(currentReportObject, currentReportPromptObject);
                  }}
                >
                  Run Report
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
    </div>
  );
};

export default ViewReport;
